/* Magic Milk – zwei Motivkarten direkt unter #mmHigh.
 * Standard, Nuss, Magic Fruit und Strawberry wechseln sich im Vierer-Zyklus ab,
 * ohne das 4:5-Layout oder die bestehenden Abstände der Sektion zu verändern.
 */
/* 29.08.2026, Mert: "das darf kein rand haben es muss perfekt rein passen"
   (gezeigt: Nuss und Magic Fruit).
   GEMESSEN war der Grund: Die Karte steht auf 4:5 (0,800), die beiden Motive
   lagen aber bei 0,671 bzw. 0,673 - also schmaler. Mit `contain` blieben links
   und rechts Baender stehen.
   Zuschneiden war keine Option: In beiden Bildern steht Text ("NUSS & CREAMY",
   "MAGIC FRUIT"), und ein Bild mit eingebautem Text wird nie beschnitten.
   Stattdessen wurde der HINTERGRUND verbreitert - jede Bildzeile mit ihrer
   eigenen Randfarbe, dadurch bleibt der senkrechte Verlauf exakt erhalten und
   es entsteht keine sichtbare Kante. Motiv und Text sind unangetastet.
   Neu: mm-beutel-nuss-v2.jpg (2022x2528) und mm-beutel-magic-fruit-v2.jpg
   (1222x1528), beide 0,7998. Magic Fruit fiel dabei von 1,9 MB auf 233 kB. */
(function () {
  'use strict';

  if (!(typeof window.mmStartseite === 'function' ? window.mmStartseite() : window.location.pathname === '/')) return;

  var DATEIEN_BASIS = (function () {
    var skript = document.currentScript;
    if (!skript || !skript.src) {
      skript = Array.prototype.slice.call(document.scripts).find(function (s) {
        return /mm-beutel-v2\.js(?:\?|$)/.test(s.src || '');
      });
    }
    return skript && skript.src ? skript.src.split('mm-beutel-v2.js')[0] : '';
  }());

  var MOTIVE = [
    {
      bild: DATEIEN_BASIS + 'mm-beutel-erdbeere-v2.jpg',
      oben: '#D41F48',
      unten: '#7A0C29',
      ziel: '/products/magic-milk-for-x5-erdbeer',
      alt: 'FOR X5 Magic Milk Strawberry – Geschmack Erdbeere, ein Stick pro Tag'
    },
    {
      bild: DATEIEN_BASIS + 'mm-beutel-orange-v1.jpg',
      oben: '#FF8300',
      unten: '#BD3100',
      ziel: '/products/magic-milk-for-x5',
      alt: 'FOR X5 Magic Milk Standard – Geschmack Neutral, ein Stick pro Tag'
    },
    {
      bild: DATEIEN_BASIS + 'mm-beutel-nuss-v2.jpg',
      oben: '#156A52',
      unten: '#08382C',
      ziel: '/products/zero-termo-milk-pro-milk',
      alt: 'ZeroTermo Pro-Milk Powder – Nuss und Creamy'
    },
    {
      bild: DATEIEN_BASIS + 'mm-beutel-magic-fruit-v2.jpg',
      oben: '#E23D73',
      unten: '#A81043',
      ziel: '/products/magic-fruit-strawberry',
      alt: 'Magic Fruit Premium – Strawberry'
    }
  ];

  var TAKT = 3800;
  var ruhig = false;
  try { ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var css = [
    '#mmBeutel{flex:0 0 auto;align-self:stretch;width:100%;box-sizing:border-box;',
    /* 06.09.2026, Mert: "immernoch hintergrund weiss machen, nicht dunkel".
       Die Sektion traegt nur Bilder, keinen sichtbaren Text - der Wechsel auf
       Weiss beruehrt hier also nichts ausser der Flaeche. */
    'background:#FFFFFF;padding:22px 0;margin:0}',
    '#mmBeutel *{box-sizing:border-box}',
    '@media(min-width:900px){#mmBeutel{padding:34px 0}}',
    '#mmBeutelInnen{max-width:1180px;margin:0 auto;padding:0 16px;',
    'display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    '@media(min-width:900px){#mmBeutelInnen{gap:20px;padding:0 20px;',
    'grid-template-columns:repeat(2,minmax(0,340px));justify-content:center}}',
    '.mmBKarte{position:relative;display:block;aspect-ratio:4/5;',
    'border-radius:18px;overflow:hidden;text-decoration:none;',
    'background:linear-gradient(180deg,var(--mmBOben),var(--mmBUnten));',
    'transition:transform .3s cubic-bezier(.22,1,.36,1),box-shadow .3s ease,',
    'background .45s cubic-bezier(.22,.61,.36,1)}',
    '@media(min-width:900px){.mmBKarte{border-radius:22px}}',
    '@media(hover:hover){.mmBKarte:hover{transform:translateY(-3px);',
    'box-shadow:0 18px 40px rgba(0,0,0,.45)}}',
    '.mmBKarte img{position:absolute;inset:0;width:100%;height:100%;',
    'object-fit:contain;display:block;opacity:0;transform:scale(.985);',
    'transition:opacity .45s cubic-bezier(.22,.61,.36,1),',
    'transform .45s cubic-bezier(.22,.61,.36,1)}',
    '.mmBKarte img.mmBAn{opacity:1;transform:none}',
    /* 29.08.2026, Mert: "ploppen lassen, smoothe animation, ohne ruckeln,
       hacken / idee: plopp, plopp, plopp..."
       Die beiden Karten kommen nacheinander herein - erst links, 130 ms spaeter
       rechts. Bewegt werden ausschliesslich `transform` und `opacity`; beides
       rechnet die Grafikkarte, deshalb ruckelt nichts. Breite, Hoehe oder
       Abstaende werden bewusst NICHT angefasst, die wuerden bei jedem Bild neu
       umbrechen und genau das Hacken erzeugen.
       Die Kurve schwingt am Ende leicht ueber (1.03) und faellt zurueck - das
       ist das "Plopp". `will-change` meldet die Bewegung vorher an, damit die
       erste Bildfolge nicht stockt, und wird danach wieder freigegeben. */
    '@keyframes mmBPlopp{',
      '0%{opacity:0;transform:translateY(14px) scale(.94)}',
      '55%{opacity:1;transform:translateY(0) scale(1.03)}',
      '75%{transform:scale(.985)}',
      '100%{opacity:1;transform:translateY(0) scale(1)}}',
    '.mmBKarte{opacity:0}',
    '.mmBKarte.mmBPlopp{will-change:transform,opacity;',
    'animation:mmBPlopp .52s cubic-bezier(.22,.68,.32,1.15) both}',
    '.mmBKarte.mmBFertig{opacity:1;will-change:auto}',
    /* Wer nicht hinsieht, bekommt keine Bewegung - und wer weniger Bewegung
       eingestellt hat, sieht die Karten einfach sofort. */
    '@media(prefers-reduced-motion:reduce){.mmBKarte{opacity:1!important;',
    'animation:none!important}}',
    '@media(prefers-reduced-motion:reduce){.mmBKarte,.mmBKarte img{transition:none}}'
  ].join('');

  function bildHtml(motiv, index, aktiv) {
    return '<img src="' + motiv.bild + '" alt="' + (aktiv ? motiv.alt : '') + '" ' +
      'data-mm-motiv="' + index + '" class="' + (aktiv ? 'mmBAn' : '') + '" ' +
      'aria-hidden="' + (aktiv ? 'false' : 'true') + '" loading="lazy" decoding="async" ' +
      'width="1120" height="1400">';
  }

  function karteHtml(start) {
    var motiv = MOTIVE[start];
    return '<a class="mmBKarte" href="' + motiv.ziel + '" aria-label="' + motiv.alt + '" ' +
      'style="--mmBOben:' + motiv.oben + ';--mmBUnten:' + motiv.unten + '">' +
      MOTIVE.map(function (bild, index) {
        return bildHtml(bild, index, start === index);
      }).join('') + '</a>';
  }

  function motivSetzen(karte, index) {
    var motiv = MOTIVE[index];
    karte.href = motiv.ziel;
    karte.setAttribute('aria-label', motiv.alt);
    karte.style.setProperty('--mmBOben', motiv.oben);
    karte.style.setProperty('--mmBUnten', motiv.unten);
    Array.prototype.forEach.call(karte.querySelectorAll('img'), function (bild) {
      var an = Number(bild.getAttribute('data-mm-motiv')) === index;
      bild.classList.toggle('mmBAn', an);
      bild.setAttribute('aria-hidden', an ? 'false' : 'true');
      bild.alt = an ? motiv.alt : '';
    });
  }

  function wechseln(sektion) {
    var karten = sektion.querySelectorAll('.mmBKarte');
    if (karten.length !== 2) return;

    var phase = 0;
    var PAARE = [[0, 1], [2, 3], [1, 0], [3, 2]];
    var timer = 0;
    var sichtbar = false;

    function zeichnen() {
      var paar = PAARE[phase % PAARE.length];
      motivSetzen(karten[0], paar[0]);
      motivSetzen(karten[1], paar[1]);
    }

    function weiter() {
      phase = (phase + 1) % PAARE.length;
      zeichnen();
    }

    function stoppen() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }

    function pruefen() {
      stoppen();
      if (!sichtbar || document.hidden) return;
      timer = window.setInterval(weiter, ruhig ? 7000 : TAKT);
    }

    zeichnen();
    if (!('IntersectionObserver' in window)) {
      sichtbar = true;
      pruefen();
      return;
    }

    var beobachter = new IntersectionObserver(function (eintraege) {
      sichtbar = !!(eintraege[0] && eintraege[0].isIntersecting);
      pruefen();
    }, { threshold: 0.12, rootMargin: '80px 0px' });

    beobachter.observe(sektion);
    document.addEventListener('visibilitychange', pruefen);
  }

  function platzHalten() {
    var sektion = document.getElementById('mmBeutel');
    var anker = document.getElementById('mmHigh');
    if (!sektion || !anker || !anker.parentNode) return;

    if (anker.nextSibling !== sektion) anker.parentNode.insertBefore(sektion, anker.nextSibling);
    var info = document.getElementById('mmInfo');
    if (info && sektion.nextSibling !== info) sektion.parentNode.insertBefore(info, sektion.nextSibling);
    var letzte = info || sektion;
    var slider = document.querySelector('[id*="st_collection_slider"]');
    if (slider && letzte.nextSibling !== slider && slider.parentNode) {
      letzte.parentNode.insertBefore(slider, letzte.nextSibling);
    }
  }

  function bauen() {
    if (document.getElementById('mmBeutel')) return true;
    var anker = document.getElementById('mmHigh');
    if (!anker || !anker.parentNode) return false;

    var stil = document.createElement('style');
    stil.id = 'mmBeutel-stil';
    stil.textContent = css;
    (document.head || document.documentElement).appendChild(stil);

    var sektion = document.createElement('section');
    sektion.id = 'mmBeutel';
    sektion.setAttribute('aria-label', 'Vier Sorten im Wechsel');
    sektion.innerHTML = '<div id="mmBeutelInnen">' + karteHtml(0) + karteHtml(1) + '</div>';

    /* Nacheinander ploppen, sobald die Sektion im Bild ist. Ein Beobachter
       statt eines Zeitgebers - sonst laeuft die Bewegung ab, waehrend niemand
       hinsieht (feste Regel vom 23.08.2026). */
    (function ploppen() {
      var karten = sektion.querySelectorAll('.mmBKarte');
      if (!karten.length) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        karten.forEach(function (k) { k.classList.add('mmBFertig'); });
        return;
      }
      function los() {
        karten.forEach(function (k, i) {
          window.setTimeout(function () {
            k.classList.add('mmBPlopp');
            /* Nach der Bewegung den Endzustand festschreiben und `will-change`
               wieder abgeben - sonst haelt der Browser die Ebene unnoetig. */
            k.addEventListener('animationend', function () {
              k.classList.add('mmBFertig');
              k.classList.remove('mmBPlopp');
            }, { once: true });
          }, i * 130);
        });
      }
      if (!('IntersectionObserver' in window)) { los(); return; }
      var wache = new IntersectionObserver(function (eintraege) {
        if (eintraege[0] && eintraege[0].isIntersecting) { wache.disconnect(); los(); }
      }, { threshold: 0.25 });
      wache.observe(sektion);
    })();
    anker.parentNode.insertBefore(sektion, anker.nextSibling);
    wechseln(sektion);
    platzHalten();
    return true;
  }

  function wache() {
    [0, 250, 600, 1200, 2200, 3500, 5000, 8000].forEach(function (ms) {
      window.setTimeout(platzHalten, ms);
    });
    window.addEventListener('load', platzHalten);
    if (!window.MutationObserver) return;
    var anker = document.getElementById('mmHigh');
    var eltern = anker && anker.parentNode;
    if (!eltern) return;
    var observer = new MutationObserver(platzHalten);
    observer.observe(eltern, { childList: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  function starten() {
    if (!bauen()) {
      var versuche = 0;
      var timer = window.setInterval(function () {
        versuche += 1;
        if (bauen() || versuche > 25) window.clearInterval(timer);
      }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { starten(); wache(); });
  } else {
    starten();
    wache();
  }
  window.addEventListener('load', function () { starten(); platzHalten(); });
}());
